import { routes } from '@/app/routes';
import HelpIconSvg from '@/assets/svgs/help-circle-outline.svg';
import AccountIconSvg from '@/assets/svgs/main/account.svg';
import CanvassersIconSvg from '@/assets/svgs/main/canvassers.svg';
import ContactListsIconSvg from '@/assets/svgs/main/contact-lists.svg';
import IdentitySvg from '@/assets/svgs/main/identity.svg';
import JobsIconSvg from '@/assets/svgs/main/jobs.svg';
import MediaIconSvg from '@/assets/svgs/main/media.svg';
import OptOutsIconSvg from '@/assets/svgs/main/opt-outs.svg';
import UsersIconSvg from '@/assets/svgs/main/users.svg';
import { useIntercomContext } from '@/lib/intercom';
import {
  selectCurrentAccountId,
  selectHasMultipleAccounts,
} from '@/lib/redux/app.selectors';
import { HTMLAttributeAnchorTarget, ReactNode } from 'react';
import { useSelector } from 'react-redux';

interface MenuLink {
  title: string;
  link: string;
  target?: React.HTMLAttributeAnchorTarget;
}

const loginFooterMenu: MenuLink[] = [
  {
    title: '&copy; Peerly',
    link: '',
    target: '_blank',
  },
  {
    title: 'Contacts',
    link: '/contacts',
    target: '_blank',
  },
  {
    title: 'Terms & Privacy',
    link: '/terms',
    target: '_blank',
  },
];

interface MenuLinkWithIcons {
  title: string;
  link?: string;
  icon: ReactNode;
  badge?: number;
  target?: HTMLAttributeAnchorTarget;
  isActive?: boolean;
  onClick?: () => void;
  groupTitle?: never;
}

interface GroupSeparator {
  title?: never;
  link?: never;
  icon?: never;
  badge?: never;
  target?: never;
  isActive?: never;
  // only
  groupTitle: string;
}
type GroupedMenuLinkWithIcons = MenuLinkWithIcons | GroupSeparator;

const useDrawerMenu = (): GroupedMenuLinkWithIcons[] => {
  const hasMultipleAccounts = useSelector(selectHasMultipleAccounts);
  const currentAccountId = useSelector(selectCurrentAccountId);
  const { openIntercom } = useIntercomContext();

  return [
    // {
    //   title: 'Overview',
    //   icon: <OverviewIconSvg className="h-5 w-5" />,
    //   link: '/',
    // },
    // {
    //   title: 'Activity',
    //   icon: <ActivityIconSvg className="h-5 w-5" />,
    //   link: '/',
    //   badge: 3,
    // },
    {
      groupTitle: 'Messaging',
    },
    {
      title: 'Jobs',
      icon: <JobsIconSvg className="h-5 w-5" />,
      link: routes.jobs,
    },
    {
      title: 'Canvassers',
      icon: <CanvassersIconSvg className="h-5 w-5" />,
      link: routes.canvassers,
    },
    {
      title: 'Media',
      icon: <MediaIconSvg className="h-5 w-5" />,
      link: routes.media,
    },
    {
      title: 'Contact Lists',
      icon: <ContactListsIconSvg className="h-5 w-5" />,
      link: routes.contactLists,
    },
    {
      title: 'Opt-Out Manager',
      icon: <OptOutsIconSvg className="h-5 w-5" />,
      link: routes.optouts,
    },
    {
      groupTitle: 'Administration',
    },
    {
      title: hasMultipleAccounts ? 'Accounts' : 'Account',
      icon: <AccountIconSvg className="h-5 w-5" />,
      link: hasMultipleAccounts
        ? routes.accounts
        : routes.accountDetails.replace('[id]', currentAccountId || ''),
    },
    {
      title: 'Users',
      icon: <UsersIconSvg className="h-5 w-5" />,
      link: routes.users,
    },
    {
      title: 'Identities',
      icon: <IdentitySvg className="h-5 w-5" />,
      link: routes.identities,
    },
    // {
    //   title: 'Integrations',
    //   icon: <IntegrationsIconSvg className="h-5 w-5" />,
    //   link: '/',
    // },
    {
      groupTitle: 'Support & Settings',
    },
    {
      title: 'Help',
      icon: <HelpIconSvg className="h-5 w-5" />,
      onClick: openIntercom,
    },
  ];
};

export { loginFooterMenu, useDrawerMenu };
